<template>
<div class="MReportCategoryList">
    <MHeader></MHeader>
    <div class="m-body">
        <div class="sort_wrap">
            <div class="sort_box" v-for="(item,index) in dataList" :key="index" @click="goSearch(item)">
                <img :src="item.imgUrl" alt="">
                <p>{{item.name}}</p>
            </div>
        </div>
    </div>
    <MTab></MTab>
</div>
</template>

<script>
import MTab from 'views/reportMobile/components/tab/mTab'
import MHeader from 'views/reportMobile/components/mheader/mHeader'
import sortList from './components/sortList.js' // 分类
import {mapActions,mapGetters} from 'vuex'
import $ from 'jquery'
export default {
    name: 'MReportCategoryList',
    data() {
        return {
            dataList:[],
        }
    },
    mounted() {
        this.dataList = sortList
    },
    activated() {
        $("html,body").animate({scrollTop:"0px"},0)
    },
    methods: {
        goSearch(obj){
           this.$router.push({name: 'MReportSearch', query: {code: obj.code}})
           this.setRefresh(true);
        },
        ...mapActions(['setLoading',  'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {
        MTab, MHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.MReportCategoryList {
    position: relative;
    padding: 0.88rem 0;
    background: $c-white;
    .m-body{
        padding: 0 0;
        .sort_wrap{
            display: flex;
            justify-content: space-between;
            flex-flow:row wrap;
            align-items:center;
            margin-top: 0.3rem;
            .sort_box{
                width: 1.7rem;
                text-align: center;
                margin-bottom: 0.6rem;
                img{
                    width: 0.64rem;
                    height: 0.64rem;
                    margin-bottom: 0.1rem;
                    display: inline-block;
                }
                p{
                    font-size: 0.28rem;
                    color: #333;
                }
            }
            .sort_box:last-child{
                visibility: hidden;
            }
        }
    }
}
</style>